import { createElement } from "react";
import { Col, Row } from "react-bootstrap";
import { useFormikContext } from "formik";
import { componentMapping } from "../../../components";
import * as validationHelper from "../../../utils/validationHelpers";

export const DynamicPlanFormFields = ({ fieldsSchema, isEdit, isSave }) => {
  const { values, handleChange, setFieldValue } = useFormikContext();

  const getValidationType = (validationName) => {
    if (validationName && validationHelper[validationName]) {
      return validationHelper[validationName];
    }
    return () => {};
  };

  const checkIsDisabled = (disabled) => {
    return new Function("isEdit", "isSave", `return ${disabled};`)(
      isEdit,
      isSave
    );
  };
  const checkShouldDisplay = (shouldDisplay) => {
    if (!shouldDisplay) return true;
    return new Function("values", `return ${shouldDisplay};`)(values);
  };
  const getOnChange = (data) => {
    switch (data.subcomponent) {
      case "FieldButtonGroup":
        return (value) => {
          setFieldValue(data.name, value);
        };
      default:
        return handleChange;
    }
  };
  return fieldsSchema?.map((data) => {
    return createElement(
      Row,
      null,
      createElement(
        Col,
        null,
        checkShouldDisplay(data.shouldDisplay)
          ? createElement(componentMapping[data.component], {
              isRequired: data.isRequired,
              name: data.name,
              size: data.size && data.size,
              label: data.label,
              noLabelTransform: true,
              type: data.type,
              autoComplete: data.autoComplete,
              value: values[data.name],
              options: data.options ? JSON.parse(data.options) : [],
              selectedValue: values[data.name],
              maxLength: data.maxLength,
              onChange: getOnChange(data),
              validate: getValidationType(data.validate),
              disabled: checkIsDisabled(data.disabled),
              component: componentMapping[data.subcomponent],
              popupContent:
                data.popupContent &&
                createElement(componentMapping[data.popupContent.component], {
                  label: data.popupContent.label,
                  name: data.popupContent.name,
                  value: values[data.popupContent.name],
                  onSelect: (value, label) => {
                    setFieldValue(data.popupContent.value, value);
                    setFieldValue(data.popupContent.name, label);
                    data.onSelect && eval(data.onSelect);
                  },
                  selectedValue: values[data.popupContent.name],
                  options: data.popupContent.options
                    ? JSON.parse(data.popupContent.options)
                    : [],
                }),
            })
          : null
      )
    );
  });
};
